module.exports = __webpack_public_path__ + "img/master-card.87d3dda0.png";